( function() {
    "use strict";

    angular
        .module("ccsTrApp")
        .service("FormulaCustomService", FormulaCustomService);

    FormulaCustomService.$inject = ['$http'];

    function FormulaCustomService($http) {
        var service = {
            returnAllFormulas: returnAllFormulas,
            returnAllFormulasByTypeAndActive: returnAllFormulasByTypeAndActive,
            calculateCurrencyConversionBD: calculateCurrencyConversionBD,
            calculateCurrencyConversionString: calculateCurrencyConversionString,
            calculateWeightUnitConversionBD: calculateWeightUnitConversionBD,
            calculateWeightUnitConversionString: calculateWeightUnitConversionString,
            calculateGrowthBaleToWeightUnitConversionBD: calculateGrowthBaleToWeightUnitConversionBD,
            calculateGrowthBaleToWeightUnitConversionString: calculateGrowthBaleToWeightUnitConversionString,
            calculateWeightUnitToGrowthBaleConversionBD: calculateWeightUnitToGrowthBaleConversionBD,
            calculateWeightUnitToGrowthBaleConversionString: calculateWeightUnitToGrowthBaleConversionString,
            sampleComputationBD: sampleComputationBD,
            sampleComputationString: sampleComputationString
        };

        return service;

        function returnAllFormulas() {
            var url = "api/formulas/all";
            return $http.get(url);
        }

        function returnAllFormulasByTypeAndActive( type, active ) {
            var url = "api/formulas?type=" + type + "&active=" + active;
            return $http.get(url);
        }

        function calculateCurrencyConversionBD( amount, rate ) {
            var url = "api/formulas/currency/bigdecimal?amount=" + amount + "&rate=" + rate;
            return $http.get(url);
        }

        function calculateCurrencyConversionString( amount, rate, result ) {
            var url = "api/formulas/currency/string?amount=" + amount + "&rate=" + rate + "&result=" + result;
            return $http.get(url);
        }

        function calculateWeightUnitConversionBD( parent, result, amount ) {
            var url = "api/formulas/weightunit/bigdecimal?parent=" + parent + "&result=" + result + "&amount=" + amount;
            return $http.get(url);
        }

        function calculateWeightUnitConversionString( parent, result, amount ) {
            var url = "api/formulas/weightunit/string?parent=" + parent + "&result=" + result + "&amount=" + amount;
            return $http.get(url);
        }

        function calculateGrowthBaleToWeightUnitConversionBD( parentGrowth, result, amount ) {
            var url = "api/formulas/growth/weightunit/bigdecimal?parentGrowth=" + parentGrowth + "&result=" + result + "&amount=" + amount;
            return $http.get(url);
        }

        function calculateGrowthBaleToWeightUnitConversionString( parentGrowth, result, amount ) {
            var url = "api/formulas/growth/weightunit/string?parentGrowth=" + parentGrowth + "&result=" + result + "&amount=" + amount;
            return $http.get(url);
        }

        function calculateWeightUnitToGrowthBaleConversionBD( parent, growthResult, amount ) {
            var url = "api/formulas/weightunit/growth/bigdecimal?parent=" + parent + "&growthResult=" + growthResult + "&amount=" + amount;
            return $http.get(url);
        }

        function calculateWeightUnitToGrowthBaleConversionString( parent, growthResult, amount ) {
            var url = "api/formulas/weightunit/growth/string?parent=" + parent + "&growthResult=" + growthResult + "&amount=" + amount;
            return $http.get(url);
        }

        function sampleComputationBD( rate, amount, type ) {
            var url = "api/formulas/sample/bigdecimal?rate=" + rate + "&amount=" + amount + "&type=" + type;
            return $http.get(url);
        }

        function sampleComputationString( rate, amount, type ) {
            var url = "api/formulas/sample/string?rate=" + rate + "&amount=" + amount + "&type=" + type;
            return $http.get(url);
        }
    }
})();
